module.exports = __webpack_public_path__ + "static/media/book8.3f631e13.jpg";